var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup579(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49091 8.72727H0V7.27273H1.49091C1.81818 4.24 4.24 1.81818 7.27273 1.49091V0H8.72727V1.49091C11.76 1.81818 14.1818 4.24 14.5091 7.27273H16V8.72727H14.5091C14.1818 11.76 11.76 14.1818 8.72727 14.5091V16H7.27273V14.5091C4.24 14.1818 1.81818 11.76 1.49091 8.72727ZM8 2.90909C6.64981 2.90909 5.35491 3.44545 4.40018 4.40018C3.44545 5.35491 2.90909 6.64981 2.90909 8C2.90909 9.35019 3.44545 10.6451 4.40018 11.5998C5.35491 12.5545 6.64981 13.0909 8 13.0909C9.35019 13.0909 10.6451 12.5545 11.5998 11.5998C12.5545 10.6451 13.0909 9.35019 13.0909 8C13.0909 6.64981 12.5545 5.35491 11.5998 4.40018C10.6451 3.44545 9.35019 2.90909 8 2.90909Z",
    fill: "#0065AA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.08984,
    y: 5.09375,
    width: 5.81818,
    height: 5.81818,
    rx: 2.90909,
    fill: "#0065AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup579);
export default __webpack_public_path__ + "static/media/Group 579.d19e6b3d2e3f2f343ca0e538a5a0aecf.svg";
export { ForwardRef as ReactComponent };